import { PiCalculatorFill } from 'react-icons/pi'

/**
 * Extract the SVG path from PiCalculatorFill and render it onto a canvas
 * for use as a Chart.js pointStyle.
 */
function extractSvgPath(): string {
  // Call the icon component function directly to get the rendered element tree
  // (createElement would only create a descriptor without calling the function)
  const el = (PiCalculatorFill as any)({}) as any
  const children = el.props?.children
  if (Array.isArray(children) && children.length > 0) {
    return children[0].props?.d || ''
  }
  return ''
}

const svgPath = extractSvgPath()

export const createCalculatorIcon = (color = '#4A9EFF'): HTMLCanvasElement => {
  const canvas = document.createElement('canvas')
  canvas.width = 20
  canvas.height = 20
  const ctx = canvas.getContext('2d')
  if (ctx && svgPath) {
    const path = new Path2D(svgPath)
    // PiCalculatorFill viewBox is "0 0 256 256" - scale to fit 20x20 canvas
    const scale = 20 / 256
    ctx.scale(scale, scale)
    ctx.fillStyle = color
    ctx.fill(path)
  }
  return canvas
}
